import React from "react";

const MarkerPicker = ({turnstiles, onPick, onClose}) => (
    <div style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50,
    }} onClick={onClose}>
        <div style={{background: "#fff", borderRadius: 8, padding: 16, minWidth: 320, maxHeight: "70vh", overflow: "auto"}}
             onClick={(e) => e.stopPropagation()}>
            <h3 className="font-bold mb-2">Vyber turniket</h3>
            <ul>
                {(turnstiles || []).map((t) => (
                    <li key={t.id}>
                        <button className="w-full text-left px-3 py-2 hover:bg-blue-50 rounded"
                                onClick={() => onPick(t)}>
                            {t.description || ("Turniket #" + t.id)} <span className="text-gray-400">#{t.id}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default MarkerPicker;
